export default __webpack_public_path__ + "static/media/user-solid-white.9a73ea0c.svg";